import { Component, forwardRef } from "react";
import { createPortal } from "react-dom";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import {
    exhibitionId,
    orderStatusActionId,
    serviceTypeId,
    stallDesignRequestStatusId,
    toastError,
    toastSuccess,
} from "../../../utils/constants";
import moment from "moment";
import Modal from "react-modal";

import StallDesign from "../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";

import { getStallDesignRequestList_action, updateStallDesignRequestStatus_action } from '../../../actions/vendor_module_action/vendor_stallDesignRequest_action'

class VendorStallDesignRequestList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            StallDesignRequestList: [],
            currentPage: 1,
            CompanyName: '',
            ExhRegistrationNo: '',
            StatusID: '',
            StatusList: [],
            StallDesignRequestID: '',
            UpdateStatusID: '',
            RefusedRemark: '',
            RefusedRemarkErr: '',
            isOpen: false,
            StatusName: '',
            isOpen2: false,
            viewRemark: '',
            viewRemarkStatusName: ''
        };
        this.updateItem = this.updateItem.bind(this);
    }

    componentDidMount() {
        this.getFillList(stallDesignRequestStatusId, "", "", "", "", "");
        this.getStallDesignRequestList()
    }
    openModal() {
        return <StallDesign />
    }

    handleManualFormModal = (serviceName, ExhRegistrationID) => {
        sessionStorage.setItem("ExhRegistrationIDSS", ExhRegistrationID);
        this.setState({
            isManualFormModalOpen: true,
            selectedServiceName: serviceName,
        });
    };

    // get fill List dropdown
    getFillList(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID,
    ) {
        const { } = this.state;
        this.setState({ isLoading: true });
        this.props
            .fill_action(
                actionID,
                exhibitionID,
                moduleID,
                keyValue,
                value,
                exhRegistrationID,
            )
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === stallDesignRequestStatusId) {
                        this.setState({
                            StatusList: data.data,
                            isLoading: false,
                        });
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // Update Current Page
    updateItem(item) {
        const { vendorRegistrationList } = this.state;
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = Array.isArray(vendorRegistrationList)
            ? vendorRegistrationList.slice(indexOfFirstRecord, indexOfLastRecord)
            : [];
        const nPages = Math.ceil(
            (vendorRegistrationList?.length || 0) / recordsPerPage,
        );
    }

    updateStallDesignRequestStatus() {
        const { StallDesignRequestID, UpdateStatusID, RefusedRemark, StatusName } = this.state;
        if (StatusName == 'Refuse' && RefusedRemark?.trim() == '') {
            this.setState({ RefusedRemarkErr: "Please enter remark", RefusedRemark: '' })
            return toastError("Please enter remark")
        }
        this.setState({ isLoading: true });
        this.props
            .updateStallDesignRequestStatus_action(StallDesignRequestID, UpdateStatusID, StatusName == 'Refuse' ? RefusedRemark : null)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess(`${StatusName == 'Approve' ? 'Approve' : 'Refuce'} Successfully!`)
                    this.setState({
                        isOpen: false,
                        StatusName: '',
                        UpdateStatusID: '',
                        StallDesignRequestID: ''
                    }, () => this.getStallDesignRequestList());
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    clearValue() {
        this.setState({
            currentPage: 1,
            CompanyName: '',
            ExhRegistrationNo: '',
            StatusID: ''
        }, () => this.getStallDesignRequestList());
    }

    getStallDesignRequestList() {
        const { CompanyName, ExhRegistrationNo, StatusID } = this.state;
        this.setState({ isLoading: true });
        this.props
            .getStallDesignRequestList_action(CompanyName, ExhRegistrationNo, StatusID != '' ? StatusID : 1)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isLoading: false,
                        StallDesignRequestList: data.data,
                    });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    RequestPop(data, status) {
        this.setState({
            isOpen: true,
            StatusName: status,
            UpdateStatusID: status == 'Approve' ? 2 : 3,
            StallDesignRequestID: data.StallDesignRequestID
        })
    }

    viewRemarkPop(data, status) {
        this.setState({
            isOpen2: true,
            viewRemark: status == 'Refuse' ? data.RefusedRemark : data.Remark,
            viewRemarkStatusName: status
        })
    }

    render() {
        const {
            isLoading,
            currentPage,
            StallDesignRequestList,
            StatusID, StatusList, RefusedRemark, RefusedRemarkErr, isOpen, StatusName,
            isOpen2, viewRemark, viewRemarkStatusName
        } = this.state;

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = StallDesignRequestList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(StallDesignRequestList.length / recordsPerPage)

        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                    <ExhibitorHeader />
                ) : (
                    <HeaderWithLogo />
                )}
                <div class="main-content vendor-top-space">
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                        <ExhibitorDrawer />
                    ) : (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17) ? (
                        <VendorDrawer />
                    ) : (
                        <AdminDrawer />
                    )}
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                        <ExhibitorTopMenu />
                    ) : null}
                    {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17)&& (
                        <div className="d-flex justify-content-end px-2 pt-3 text-aqua">
                            {/* <span
                                onClick={() => this.setState({ showVideoModal: true })}
                                style={{
                                    cursor: "pointer",
                                    color: "#3dbca7",
                                    fontSize: "16px",
                                    marginLeft: "auto",
                                }}
                            >
                                <i className="bi bi-play-circle-fill me-2"></i>User Manual
                            </span> */}
                        </div>
                    )}
                    {/* <div class="row">
                        <div class="step-name">
                            <p>Service Partner Registration List</p>
                        </div>
                    </div> */}

                    <div class="row m-0">
                        <div className="col-md-3">
                            <label>Application Registration No</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.ExhRegistrationNo}
                                onChange={(e) =>
                                    this.setState({ ExhRegistrationNo: e.target.value })
                                }
                                placeholder="Search ExhRegistrationNo"
                            />
                        </div>
                        <div className="col-md-3">
                            <label>Company Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.CompanyName}
                                onChange={(e) =>
                                    this.setState({ CompanyName: e.target.value })
                                }
                                placeholder="Search Company Name"
                            />
                        </div>
                        <div className="col-md-3">
                            <label>Status</label>
                            <select className="form-control"
                                value={StatusID}
                                // disabled={isView}
                                onChange={(e) => this.setState({ StatusID: e.target.value })}  >
                                <option value={''}>Select</option>
                                {/* <option value={0}>All</option> */}
                                {
                                    StatusList.length > 0 && StatusList.map(data => (
                                        <option value={data.StallDesignRequestStatusID} key={data.StallDesignRequestStatusID}>{data.Description}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>&emsp;</label>
                            <div
                                className="mb-1"
                                aria-label="Basic example"
                                style={{ float: "left" }}
                            >
                                <button type="button" className="btn btn-aqua mt-1 "
                                    onClick={e => this.getStallDesignRequestList()}
                                >
                                    search
                                </button>
                                <button type="button" className="btn btn-gray mt-1 mx-2"
                                    onClick={e => this.clearValue()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive mb-5 p-2 mt-2">
                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Application Registration No</th>
                                    <th className="text-center">Hall No</th>
                                    <th className="text-center">Stall No</th>
                                    <th>Company Name</th>
                                    <th>Person Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th className="text-center">Exhibitor Remark</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-center">Approve/Refuse</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRecords.length > 0 && currentRecords != null ? (
                                    currentRecords.map((data, i) => (
                                        <tr style={{ cursor: "pointer" }}>
                                            <td>{data.ExhRegistrationNo || "-"}</td>
                                            <td className="text-center">{data.HallNo || "-"}</td>
                                            <td className="text-center">{data.StallNo || "-"}</td>
                                            <td>{data.CompanyName || "-"}</td>
                                            <td>{data.name || "-"}</td>
                                            <td>{data.Email || "-"}</td>
                                            <td>{data.MobileNo || "-"}</td>
                                            <td className="text-center">{data.Remark ? <i class="fa fa-commenting-o text-aqua" title="View Exhibitor Remark"
                                                onClick={() => this.viewRemarkPop(data, 'Remark')}
                                            ></i> : "-"}</td>
                                            <td className={`text-center ${data.StatusID == 1 || data.StatusID == 2 ? 'text-aqua' : 'text-danger'}`}>
                                                {data.StatusName || "-"}&nbsp;
                                                {data.StatusID == 3 && data.StatusName ? <i class="bi bi-info-circle text-aqua" title="View Refused Remark"
                                                    onClick={() => this.viewRemarkPop(data, 'Refuse')}
                                                ></i> : ""}</td>
                                            <td className="text-center">
                                                {data.StatusID == 1 ?
                                                    <>
                                                        <i class="fa fa-check text-aqua" title="Approve"
                                                            onClick={() => this.RequestPop(data, 'Approve')}
                                                        ></i>&ensp;|&ensp;
                                                        <i class="fa fa-times text-danger" title="Refuse"
                                                            onClick={() => this.RequestPop(data, 'Refuse')}></i>
                                                    </> :
                                                    data.StatusID == 2 ?
                                                        "-" :
                                                        <i class="fa fa-check text-aqua" title="Approve"
                                                            onClick={() => this.RequestPop(data, 'Approve')}></i>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                            Record not found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="m-2 float-left trp">
                        {StallDesignRequestList.length > 0 ? (
                            <Pagination
                                nPages={nPages}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                            />
                        ) : (
                            <></>
                        )}
                        <div className="table-record-pages">
                            <p>{`${currentPage} of ${nPages} pages`}</p>
                        </div>
                    </div>
                </div>


                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false, StatusName: '' })}>
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header text-white p-2">
                                <h6 className="modal-title fw-normal">
                                    {StatusName == 'Approve' ? 'Confirm!' : 'Refused Remark'}
                                </h6>
                                <button
                                    type="button "
                                    class="btn-close btn-close-white"
                                    data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false, StatusName: '' })}
                                >
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="col-xl-12 mb-1">
                                        {StatusName == 'Approve' ?
                                            <p>Are you sure you want to approve?</p> :
                                            <>
                                                <label htmlFor="validationCustom03">
                                                    Refused Remark<span className="text-red">*</span>
                                                </label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    rows={10}
                                                    value={RefusedRemark}
                                                    maxLength={2000}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            RefusedRemark: e.target.value,
                                                            RefusedRemarkErr: "",
                                                        })
                                                    }
                                                />
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {RefusedRemarkErr}
                                                    </span>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    className={`btn ${StatusName == 'Approve' ? 'btn-aqua' : 'btn-danger'} mx-2`}
                                    onClick={() => this.updateStallDesignRequestStatus()}
                                >
                                    {StatusName == 'Approve' ? 'Approve' : 'Refuse'}
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-gray"
                                    data-dismiss="modal"
                                    style={{ marginLeft: "5px" }}
                                    onClick={() => this.setState({ isOpen: false, StatusName: '' })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={isOpen2} onRequestClose={() => this.setState({ isOpen2: false, viewRemarkStatusName: '', viewRemark: '' })}>
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header text-white p-2">
                                <h6 className="modal-title fw-normal">
                                    {viewRemarkStatusName == 'Refuse' ? 'Refused Remark' : 'Exhibitor Remark'}
                                </h6>
                                <button
                                    type="button "
                                    class="btn-close btn-close-white"
                                    data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen2: false, viewRemarkStatusName: '', viewRemark: '' })}
                                >
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="col-xl-12 mb-1">
                                        <label htmlFor="validationCustom03">
                                            Remark<span className="text-red">*</span>
                                        </label>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            rows={10}
                                            disabled={true}
                                            value={viewRemark}
                                            maxLength={2000}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-gray"
                                    data-dismiss="modal"
                                    style={{ marginLeft: "5px" }}
                                    onClick={() => this.setState({ isOpen2: false, viewRemarkStatusName: '', viewRemark: '' })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

            </>
        );
    }
}
export default withRouter(
    connect(null, {
        fill_action,
        getStallDesignRequestList_action, updateStallDesignRequestStatus_action
    })(VendorStallDesignRequestList),
);
